/**
 * "Novidades" (What's New) — the maintained list shown by WhatsNewDialogComponent.
 *
 * HOW TO ADD A RELEASE NOTE
 *  1. Prepend an entry here (the list is NEWEST FIRST — the first entry is
 *     what the topbar dot keys on). `id` is the i18n suffix:
 *     WHATS_NEW.ITEMS.<id>.TITLE / .BODY / (.BODY2 when twoParagraphs) / .META
 *  2. Add those keys to the 8 locale files (usual python i18n script).
 *  3. Once the list passes WHATS_NEW_MAX_ITEMS (25), delete the OLDEST
 *     entries from the tail — and their WHATS_NEW.ITEMS.* keys from the 8
 *     locales. Until then the list just grows (the dialog scrolls).
 *
 * Only FEATURES belong here; bug fixes are not announced.
 */
export type WhatsNewCategory = 'PRODUCTS' | 'EDITOR' | 'SHARES' | 'SUPPORT' | 'CATALOG' | 'PROFILE';

export interface WhatsNewEntry {
  /** i18n suffix under WHATS_NEW.ITEMS.* */
  id: string;
  /** Category label — WHATS_NEW.CATS.<cat> */
  cat: WhatsNewCategory;
  /** Release date (informational; ordering is manual, newest first). */
  date: string;
  /** Renders a second BODY2 paragraph. */
  twoParagraphs?: boolean;
}

export const WHATS_NEW_ITEMS: WhatsNewEntry[] = [
  { id: 'FOLDER_FILTERS', cat: 'PRODUCTS', date: '2026-08-26', twoParagraphs: true },
  { id: 'MULTI_PROJECT', cat: 'PRODUCTS', date: '2026-08-24', twoParagraphs: true },
  { id: 'SHARE_GUEST_ACCESS', cat: 'SHARES', date: '2026-08-23' },
  { id: 'FILE_ALBUM_SHARE', cat: 'SHARES', date: '2026-08-21' },
  { id: 'EDITOR_PAGE_ARROWS', cat: 'EDITOR', date: '2026-08-21' },
  { id: 'HOME_TAG_SHORTCUTS', cat: 'CATALOG', date: '2026-08-20' },
  { id: 'EDITOR_BG_ALL_PAGES', cat: 'EDITOR', date: '2026-08-19' },
  { id: 'MY_LOGOS', cat: 'PROFILE', date: '2026-08-19' },
  { id: 'EDITOR_AUTOSAVE', cat: 'EDITOR', date: '2026-08-18' },
  { id: 'EDITOR_UNIT_TOGGLE', cat: 'EDITOR', date: '2026-08-17' },
  { id: 'HOME_PRODUCT_SEARCH', cat: 'CATALOG', date: '2026-08-17' }
];

/**
 * Display cap: the dialog renders at most this many entries (newest first,
 * scrolling). The list should be hand-trimmed once it grows past this.
 */
export const WHATS_NEW_MAX_ITEMS = 25;

/** The dot on the topbar pill clears once THIS id is stored as seen. */
export const WHATS_NEW_LATEST_ID: string = WHATS_NEW_ITEMS[0]?.id ?? '';
export const WHATS_NEW_SEEN_STORAGE_KEY = 'dbp_whats_new_seen_id';
